// extracted by mini-css-extract-plugin
export default {"icon":"jut__SortingTrigger__icon","inactive":"jut__SortingTrigger__inactive"};